import { checkValidator } from "../validator";
import Client from "../request";
const wxAppId = process.env.Wechat_MiniAppId;

/**
 * @description 一个用户注册
 */
export class SignupController {
    name = "";
    gender = 0;
    avatar = "";

    /**登录手机号 */
    phone = "";
    /**手机号验证码 */
    phoneCaptcha = "";

    /**登录密码 */
    password = "";
    rePassword = "";

    errors = {};

    miniQrcodeToken = "";

    // 小程序二维码
    qrcode = "";
    qrcodeScene = "";
    qrcodeScanStatus = "0";

    // 手机号验证码
    captchaCountDown = 0;
    captchaRequesting = false;
    captchaCountDownTimer = null;

    privacyPolicy = false;

    async getMiniQrcode() {
        let {
            data: { image, scene },
        } = await Client.post(`/wx/mp/${wxAppId}/signup/qrcodewithtoken`);
        this.qrcode = image;
        this.qrcodeScene = scene;
        this.qrcodeScanStatus = "0";

        this.getQrcodeStatus();
    }

    async getQrcodeStatus() {
        if (this.qrcodeScene) {
            try {
                let {
                    data: token,
                } = await Client.get(
                    `/wx/mp/${wxAppId}/signup/qrcodewithtoken`,
                    {
                        scene: this.qrcodeScene,
                    },
                    { noMessage: true }
                );
                this.miniQrcodeToken = token;
            } catch (e) {
                this.qrcodeScanStatus = e.message;
                // 0  待扫描 1 已扫描 2 已授权 3 已拒绝
                if (["0", "1"].includes(this.qrcodeScanStatus)) {
                    this.getQrcodeStatus();
                }
            }
        }
    }

    async getPhoneCaptcha() {
        if (!/^1\d\d{9}$/.test(String(this.phone))) {
            return (this.errors = { phone: "手机号码填写有误" });
        }
        this.errors = {};
        this.captchaRequesting = true;
        //
        this.captchaCountDown = 60;
        this.startCaptchaCountDown();
        this.captchaRequesting = false;
    }

    startCaptchaCountDown() {
        this.captchaCountDown--;
        if (this.captchaCountDown > 0) {
            this.captchaCountDownTimer = setTimeout(() => {
                this.startCaptchaCountDown();
            }, 1000);
        }
    }

    async validate() {
        const model = this.toJSON();
        const errors = await checkValidator(model, {
            name: [
                { max: 30, message: "昵称不能超过30个字符" },
            ],
            gender: [
                {
                    type: "enum",
                    enum: [0, 1, 2],
                    message: "请选择保密、男或女",
                },
            ],
            phone: [
                {
                    type: "string",
                    required: true,
                    message: "请填写手机号码",
                },
                {
                    type: "string",
                    pattern: /^1\d\d{9}$/,
                    message: "请填写正确的手机号",
                },
            ],
            phoneCaptcha: [
                {
                    type: "string",
                    required: true,
                    message: "请填写验证码",
                },
                {
                    type: "string",
                    pattern: /^[0-9a-z]{6}$/i,
                    message: "验证码是一组6位字符",
                },
            ],
            password: [
                {
                    type: "string",
                    validator: (rule, value, cb) => {
                        if (!String(value).length) {
                            return cb(new Error("请填写登录密码"));
                        } else if (value.length < 8) {
                            return cb(new Error("密码至少8位"));
                        } else {
                            const hasNumber = /[0-9]{1}/.test(value);
                            const hasUpper = /[A-Z]{1}/.test(value);
                            const hasLower = /[a-z]{1}/.test(value);
                            const hasOther = /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/.test(
                                value
                            );
                            if (
                                [
                                    hasNumber,
                                    hasUpper,
                                    hasLower,
                                    hasOther,
                                ].filter(Boolean).length < 2
                            ) {
                                return cb(
                                    new Error(
                                        "密码请使用 数字、大写、小写、特殊字符 两种以上组合"
                                    )
                                );
                            } else {
                                cb();
                            }
                        }
                    },
                },
            ],
            rePassword: [
                {
                    type: "string",
                    validator: (rule, value, cb) => {
                        if (value == model.password) {
                            cb();
                        } else {
                            cb(new Error("两次密码输入不一致"));
                        }
                    },
                },
            ],
            miniQrcodeToken: [
                {
                    type: "string",
                    required: true,
                    message: "注册token缺失，请刷新页面重试",
                },
            ],
            privacyPolicy: [
                {
                    validator: (rule, value, cb) => {
                        if (value) {
                            cb();
                        } else {
                            cb(new Error("您必须同意隐私政策才能继续注册"));
                        }
                    },
                },
            ],
        });
        if (errors) {
            this.errors = errors;
            throw new Error("请检查表单");
        }
    }

    toJSON() {
        return {
            name: this.name || '匿名用户',
            gender: this.gender,
            avatar: this.avatar,
            phone: this.phone,
            phoneCaptcha: this.phoneCaptcha,
            password: this.password,
            rePassword: this.rePassword,
            miniQrcodeToken: this.miniQrcodeToken,
            privacyPolicy: this.privacyPolicy
        };
    }
}
